import Vue from 'vue';
import {
  getNextOfKinModel
} from './models';

export default {
  setLoading(state, loading) {
    state.loading = loading;
  },

  setError(state, error) {
    state.loading = false;
    state.error = error;
  },

  setData(state, data) {
    state.data = {
      ...state.data,
      ...data
    }
  },

  setHolidays(state, holidays) {
    state.holidays = holidays;
  },

  setExcursion(state, excursionTotalPrice) {
    state.booking.payment.fullBalance = excursionTotalPrice;
  },
  
  setDisabledTabs(state, tabsDisabled) {
    state.tabsDisabled = tabsDisabled;
  },

  setEqual(state, data) {
    state.hideCustomAmountOption = data;
  },

  setBooking(state, booking) {

    booking.passengers.forEach(passenger => {
      if (!passenger.emergencyContacts.length) {
        passenger.emergencyContacts.push({
          ...getNextOfKinModel(),
        });
      }
    });

    state.booking = {
      ...state.booking,
      ...booking,
      excursions: [], // TODO: Remove when excursion work has been done
      subtotal: 0
    };
  },

  setDepartureDetails(state, departureDetails) {
    state.booking = {
      ...state.booking,
      departureDetails
    };
  },

  setPayment(state, payment) {
    state.booking = {
      ...state.booking,
      payment
    }
  },

  setPaymentFrame(state, paymentFrame) {
    state.paymentFrame = paymentFrame;
  },

  setPaymentAmount(state, data) {
    state.paymentAmount = data;
  },

  setPaymentSuccess(state, data) {
    state.paymentSuccess = data;
  },

  setPaymentError(state, data) {
    state.paymentError = data;
  },

  setCardTypeId(state, data) {
    state.cardTypeId = data;
  },

  setExcursionData(state, excursionData) {
    state.booking = {
      ...state.booking,
      excursionData
    }
  },

  togglePassengerExcursion(state, {
    passenger,
    excursion
  }) {

    let theExcursion = state.booking.excursions.find(e => e.excursionId === excursion.id);
    if (!theExcursion) {
      theExcursion = {
        excursionId: excursion.id,
        passengers: [],
        price: excursion.price
      };
      state.booking.excursions.push(theExcursion);
    }

    let thePassenger = theExcursion.passengers.find(p => p.passengerId === passenger.passengerId);
    if (!thePassenger) {
      thePassenger = {
        passengerId: passenger.passengerId,
        selected: true
      };
      theExcursion.passengers.push(thePassenger);
    } else {
      thePassenger.selected = !thePassenger.selected;
    }

    state.booking.subtotal = 0;
    
    state.booking.subtotal = state.booking.excursions.reduce((total, excursion) => {
      return total + excursion.passengers.reduce((passengerTotal, passenger) => {
        return passengerTotal + (passenger.selected ? excursion.price : 0);
      }, 0);
    }, 0);
  },

  setVisas(state, visas) {
    state.booking = {
      ...state.booking,
      visas
    };
  },

  setUserDetails(state, data) {
    state.userDetails = data;
  },

  setActivePassengerSection(state, data) {
    Vue.set(state.booking.passengers[data.index], 'activeSection', data.title);
  },

  addNextOfKin(state, passengerIndex) {
    state.booking.passengers[passengerIndex].emergencyContacts.push(getNextOfKinModel());
  },

  removeNextOfKin(state, data) {
    state.booking.passengers[data.passengerIndex].emergencyContacts.splice(data.index, 1);
  }
}